if(typeof _GIRL_CONF['frecly']['game_memory']=='undefined'){_GIRL_CONF['frecly']['game_memory']={};};
_GIRL_CONF['frecly']['game_memory']['face']={left:580,top:112,width:185,height:343};
_GIRL_CONF['frecly']['game_memory']['hair']={left:473,top:30,width:333,height:349};
_GIRL_CONF['frecly']['game_memory']['hand']={left:515,top:267,width:164,height:299};
_GIRL_CONF['frecly']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['frecly']['game_memory']['item2']={left:958,top:362,width:146,height:293};
_GIRL_CONF['frecly']['game_memory']['item3']={left:347,top:594,width:594,height:138};
_GIRL_CONF['frecly']['game_memory']['tits']={left:607,top:384,width:159,height:135};
